import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import classNames from 'classnames'
import { twMerge} from 'tailwind-merge'
import { Menu, Transition } from '@headlessui/react'
import { Button, MenuButton } from '@arnsbogroup/react-voicearchive'
import { usePopper } from 'react-popper'

export const DropdownMenu = ({ button, items, ...props }) => {
  let [referenceElement, setReferenceElement] = useState()
  let [popperElement, setPopperElement] = useState()

  let { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-end',
    strategy: 'fixed',
    modifiers: [{ name: 'offset', options: { offset: [0, 10] } }],
  })

  return (
    <Menu
      as="div"
      className="shrink-0 relative"
      {...props}
    >
      <Menu.Button
        ref={setReferenceElement}
        as={Button}
        {...button}
      />

      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
          <Menu.Items
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
            className="z-50 w-80 bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            { items.map((item, index) => (
              <Menu.Item key={index}>
                {(itemProps) => (
                  <MenuButton {...itemProps } {...item} />
                )}
              </Menu.Item>
            )) }
          </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default DropdownMenu
